import React from 'react';

import { checkComputer } from '@app/services/cades';
import { CertificateStore, IComputerCheck } from '@app/services/cades/interfaces';

export const useComputerCheck = (store = CertificateStore.Personal) => {
  const [result, setResult] = React.useState<IComputerCheck>();
  const [running, setRunning] = React.useState(false);
  const [attempt, setAttempt] = React.useState(0);

  React.useEffect(() => {
    let active = true;
    setResult(undefined);
    setRunning(true);
    checkComputer(store).then((value) => {
      if (active) {
        setResult(value);
        setRunning(false);
      }
    });
    return () => {
      active = false;
    };
  }, [store, attempt]);

  return { result, running, recheck: () => setAttempt((value) => value + 1) };
};
